import services from "@/http";
import * as types from "./mutation-types";
import * as storage from "../storage";

export const ActionGetAll = async ({ dispatch }, payload) => {
  const data = await dispatch("ActionFind", payload);
  dispatch("ActionSetAreas", data.data);
  dispatch("ActionSetPagination", data.meta);
};

export const ActionFind = async (store, search) => {
  try {
    const { data } = await services.areas.get_all(search);
    return data;
  } catch (err) {
    return {
      data: [],
      meta: {},
    };
  }
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.areas.show({ id: id }).then((res) => {
    dispatch("ActionSetArea", res.data.area);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }

  try {
    dispatch("ActionArvore", true);
  } catch (error) {}
};

export const ActionStore = async ({ commit }, payload) => {
  await services.areas.store(payload).then((res) => {
    commit(types.SET_AREA, res.data.area);
  });
};

export const ActionUpdate = async ({ commit, dispatch }, payload) => {
  await services.areas.update({ id: payload.id }, payload).then((res) => {
    commit(types.SET_AREA, res.data.area);
  });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.areas.delete({ id: id }).then(() => {
    commit(types.SET_AREA, null);
  });
};

export const ActionSetAreas = ({ commit }, payload) => {
  commit(types.SET_AREAS, payload);
};

export const ActionSetArea = ({ commit }, payload) => {
  commit(types.SET_AREA, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewArea = ({ commit }) => {
  const area = {
    nome: "",
    descricao: "",
    status: true,
    area_id: null,
  };
  commit(types.SET_AREA, area);
};

export const ActionArvore = async ({ dispatch }, reset = false) => {
  let response = storage.getAreasToSelect();

  if (reset) response = [];

  if (!response || !response.length) {
    const { data } = await services.areas.arvore();
    response = data.arvore;
    storage.setAreasToSelect(response);
  }

  return response;
};
